import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=23d8417c&scoped=true"
import script from "./Advertisement.vue?vue&type=script&lang=js"
export * from "./Advertisement.vue?vue&type=script&lang=js"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=23d8417c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8417c",
  null
  
)

export default component.exports